import { render, staticRenderFns } from "./DayOffRestaurantList.vue?vue&type=template&id=78d37f93&scoped=true"
import script from "./DayOffRestaurantList.vue?vue&type=script&lang=js"
export * from "./DayOffRestaurantList.vue?vue&type=script&lang=js"
import style0 from "./DayOffRestaurantList.vue?vue&type=style&index=0&id=78d37f93&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d37f93",
  null
  
)

export default component.exports